var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/modules/_shared-key.js